module.exports = __webpack_public_path__ + "ui-static/img/logo-launcher_light.e370431d.svg";